import React from 'react';
import type { Dispatch } from 'react';

import Select from '@atlaskit/select';

import type { FilterKeys, SelectOptions } from './filtersDefinitions.ts';
import {
	FilterHeaderCompiled,
	InputContainerCompiled,
	SelectContainerCompiled,
} from './presentationalComponents.tsx';

interface SelectFilterProps<T> {
	filterKey: FilterKeys; // Used to determine which filter to update in context.
	options: SelectOptions<T>[]; // The options to pass the select.
	label: string;
	inputId: string;
	filterDispatch?: Dispatch<any>;
	value?: SelectOptions<T> | null;
	onChange?: (props) => void;
}

export const SelectFilter = <T extends unknown>({
	options,
	filterKey,
	label,
	inputId,
	filterDispatch,
	onChange,
	value,
}: SelectFilterProps<T>) => {
	const onFilterChange = (props: SelectOptions<T> | null) => {
		if (onChange) {
			onChange(props);
		} else if (filterDispatch) {
			filterDispatch({ type: filterKey, payload: props?.value });
		}
	};

	return (
		<InputContainerCompiled>
			<FilterHeaderCompiled htmlFor={inputId}>{label}</FilterHeaderCompiled>
			<SelectContainerCompiled>
				<Select
					id={inputId}
					options={options}
					value={value}
					onChange={onFilterChange}
					isSearchable={false}
					testId={inputId}
					classNamePrefix="react-select"
				/>
			</SelectContainerCompiled>
		</InputContainerCompiled>
	);
};
